const DATA_PATH = '/data/tenants/9';

export function getInsightDataBasePath(): string {
  return DATA_PATH;
}

export function useInsightDataPath(): string {
  return DATA_PATH;
}

export default useInsightDataPath;
